<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M7.54285 6.85722L6.85714 7.54293L11.3143 12L6.85721 16.4571L7.54292 17.1428L12 12.6857L16.4571 17.1429L17.1428 16.4571L12.6857 12L17.1429 7.54285L16.4571 6.85714L12 11.3143L7.54285 6.85722Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 19.7143C16.2605 19.7143 19.7143 16.2605 19.7143 12C19.7143 7.73952 16.2605 4.28571 12 4.28571C7.73952 4.28572 4.28571 7.73952 4.28571 12C4.28571 16.2605 7.73952 19.7143 12 19.7143Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
